export const PREPARE_MEDCARD_STORAGE_KEY = 'prepare_medcard_storage_key'

export const UNSENT_MESSAGES_STORAGE_KEY = 'unsent_messages'

export const UNSENT_DOCTOR_QUESTIONS_KEY = 'unsent_doctors_questions'

export const TELEMED_TEXT_STORAGE_KEY = 'telemed_text'

export const COOKIE_CONSENT_STORAGE_KEY = 'cookie_consent'
